import {
  FETCH_PROJECTS,
  FETCH_ABOUT_DATA,
  FETCH_COOKIE_DATA,
  TOGGLE_NAVIGATION,
  FETCH_DOWNLOADS,
  FETCH_TAXONOMY,
  SET_CURRENT_FILTER,
  FETCH_JOBS,
  FETCH_CONTACT_FORM,
  SUBMIT_CONTACT_FORM,
  FETCH_NEWS,
  SELECT_NEWS,
  FETCH_HOMEPAGE_DATA,
  SELECT_PROJECT,
  SELECT_JOB,
  FETCH_SINGLE_NEWS,
  DETECT_MOUSE_STATE,
  FETCH_CONTACT_DATA
} from "../constants/actionTypes";
import { calculateSig } from "../helpers/functions";
import { CMS_URL } from "../constants/cmsData";
import axios from "axios";

// export function fetchMainNavigation() {
//   return dispatch => {
//     axios.get(`${CMS_URL}wp-api-menus/v2/menus/3`).then(navigation => {
//       dispatch({
//         type: FETCH_MAIN_NAVIGATION,
//         payload: navigation.data
//       });
//     });
//   };
// }

// export function fetchRoutes() {
//   return dispatch => {
//     axios
//       .get(`${CMS_URL}wp-api-menus/v2/menus/2`)
//       .then(routes => {
//         dispatch({
//           type: FETCH_ROUTES,
//           payload: routes.data
//         });
//       })
//       .catch(error => console.log(error));
//   };
// }

export function fetchDownloads() {
  return dispatch => {
    axios
      .get(`${CMS_URL}wp/v2/downloads_items?per_page=100`)
      .then(downloads => {
        dispatch({
          type: FETCH_DOWNLOADS,
          payload: downloads.data
        });
      })
      .catch(error => console.log(error));
  };
}

export function fetchNews(offset) {
  const offsetParameter = offset ? `&offset=${offset}` : "";
  return dispatch => {
    axios
      .get(`${CMS_URL}wp/v2/posts?per_page=10${offsetParameter}`)
      .then(news => {
        dispatch({
          type: FETCH_NEWS,
          payload: news.data
        });
      });
  };
}
export function fetchSingleNews(slug) {
  return dispatch => {
    axios
      .get(`${CMS_URL}wp/v2/posts?slug=${slug}`)
      .then(news => {
        dispatch({
          type: FETCH_SINGLE_NEWS,
          payload: news.data
        });
      })
      .catch(error => {
        if (error) {
          window.location.href = "/not-found";
        }
      });
  };
}

export function fetchJobs() {
  return dispatch => {
    axios.get(`${CMS_URL}wp/v2/job_opportunities?`).then(jobs => {
      dispatch({
        type: FETCH_JOBS,
        payload: jobs.data
      });
    });
  };
}

export function fetchTaxonomy(taxonomy, label) {
  return dispatch => {
    axios.get(`${CMS_URL}wp/v2/${taxonomy}`).then(taxonomy => {
      dispatch({
        type: FETCH_TAXONOMY,
        payload: { [label]: taxonomy.data }
      });
    });
  };
}
// export function fetchNewsTaxonomy() {
//   return dispatch => {
//     axios.get(`${CMS_URL}wp/v2/categories`).then(taxonomy => {
//       dispatch({
//         type: FETCH_NEWS_TAXONOMY,
//         payload: taxonomy.data
//       });
//     });
//   };
// }

// export function detectRouteAnimation() {
//   return {
//     type: DETECT_ROUTE_ANIMATION
//   };
// }

export function setCurrentFilter(filter, category, id) {
  return {
    type: SET_CURRENT_FILTER,
    payload: {
      [category]: {
        slug: filter,
        id
      }
    }
  };
}

export function handleContactForm(publicKey, privateKey, method, values) {
  const d = new Date();
  const expiration = 3600; // 1 hour,
  const unixtime = parseInt(d.getTime() / 1000, 10);
  const future_unixtime = unixtime + expiration;
  const route = method === "GET" ? "forms/1" : "forms/1/submissions";

  let stringToSign =
    publicKey + ":" + method + ":" + route + ":" + future_unixtime;
  let sig = calculateSig(stringToSign, privateKey);
  let url =
    "https://admin.s-harrison.co.uk/gravityformsapi/" +
    route +
    "?api_key=" +
    publicKey +
    "&signature=" +
    sig +
    "&expires=" +
    future_unixtime;

  if (method === "GET") {
    return dispatch => {
      axios.get(url).then(response => {
        dispatch({
          type: FETCH_CONTACT_FORM,
          payload: response
        });
      });
    };
  } else if (method === "POST") {
    let valuesEdit = {
      input_values: { ...values }
    };
    return dispatch => {
      axios
        .post(url, JSON.stringify(valuesEdit))
        .then(response => {
          dispatch({
            type: SUBMIT_CONTACT_FORM
          });
        })
        .catch(error => console.log(error));
    };
  }
}

export function fetchProjects() {
  return dispatch => {
    axios.get(`${CMS_URL}wp/v2/projects_items?per_page=100`).then(projects => {
      dispatch({
        type: FETCH_PROJECTS,
        payload: projects.data
      });
    });
  };
}

export function selectNews(slug) {
  return {
    type: SELECT_NEWS,
    payload: slug
  };
}
export function selectProject(slug) {
  return {
    type: SELECT_PROJECT,
    payload: slug
  };
}
export function selectJob(slug) {
  return {
    type: SELECT_JOB,
    payload: slug
  };
}

export function fetchAboutData() {
  return dispatch => {
    fetch(`${CMS_URL}wp/v2/pages/?slug=about`)
      .then(res => res.json())
      .then(pageData => {
        dispatch({
          type: FETCH_ABOUT_DATA,
          payload: pageData
        });
      });
  };
}

export function fetchCookieData() {
  return dispatch => {
    fetch(`${CMS_URL}wp/v2/pages/?slug=cookie-and-privacy-policy`)
      .then(res => res.json())
      .then(pageData => {
        dispatch({
          type: FETCH_COOKIE_DATA,
          payload: pageData
        });
      });
  };
}
export function fetchContactData() {
  return dispatch => {
    fetch(`${CMS_URL}wp/v2/pages/?slug=contact`)
      .then(res => res.json())
      .then(pageData => {
        dispatch({
          type: FETCH_CONTACT_DATA,
          payload: pageData
        });
      });
  };
}

export function detectMouseState(mouseState) {
  return {
    type: DETECT_MOUSE_STATE,
    payload: mouseState
  };
}

export function fetchHomepageData() {
  return dispatch => {
    fetch(`${CMS_URL}wp/v2/pages/?slug=home`)
      .then(res => res.json())
      .then(homepageData => {
        dispatch({
          type: FETCH_HOMEPAGE_DATA,
          payload: homepageData
        });
      });
  };
}

export function toggleNavigation() {
  return {
    type: TOGGLE_NAVIGATION
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js